module.exports = "<div id=\"coachmarkBackground\" *ngIf=\"show\"></div>\r\n\r\n<div id=\"gotIt\" *ngIf=\"show\">\r\n    <span id=\"addUserTxt\" [innerHTML]=\"'Add users to your house' | translate\"></span><br>\r\n    <input id=\"gotItBtn\" class=\"fowardBtn\" type=\"submit\" [value]=\"('GOT IT!' | translate)\" (click)=\"gotIt()\" >\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/coachmarks/coachmark-users/coachmark-users.component.html
// module id = ./src/app/shared/components/coachmarks/coachmark-users/coachmark-users.component.html
// module chunks = main